import styled from 'styled-components';
import { H1, H2, SectionParent, BlueButton } from '../../StyledComponents';
import Mobile from '../../../assets/v2/Partner/Mobile-cover.png';

import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';
import { create } from '@lottiefiles/lottie-interactivity';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Fade from 'react-reveal/Fade';
import { navigate } from 'gatsby';
require('./pricing.scss');

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f9fbfe;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(24, 1fr);
  // padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #151828;
  font-size: 48px !important;
  margin-top: 12rem;
  @media (max-width: 1024px) {
    // margin-left: 0rem;
    // margin-right: 0rem;
    // text-align: center;
    font-size: 36px !important;
  }
  @media (max-width: 769px) {
    margin-left: 0rem;
    margin-right: 0rem;
    text-align: center;
    font-size: 30px !important;
  }
  @media (max-width: 520px) {
    // color: #ac93ff;
    font-size: 24px !important;
  }
`;

const GridLeft = styled.div`
  grid-column: span 11;
  // padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  margin-right: -5rem;
  align-content: center;
  display: grid;
  min-height: 45rem;

  @media (max-width: 1200px) {
    margin-top: 7rem;
  }
  @media (max-width: 1024px) {
    margin-top: 1rem;
  }
  @media (max-width: 768px) {
    grid-column: span 24;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 25rem;
    width: 100%;
  }
`;
const GridRight = styled.div`
  grid-column: span 12;
  // padding-left: 7rem;
  position: relative;
  min-height: 760px;
  margin-left: -20%;
  margin-top: 6rem;
  right: -14rem;
  @media (max-width: 1100px) {
    padding-left: 0;
    right: -12rem;
    overflow-x: hidden;
    grid-column: span 10;
    margin-top: 1rem;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
const GridMobile = styled.div`
  // margin-left: 25%;
  overflow-x: hidden;
  @media (min-width: 769px) {
    display: none;
  }
  @media (max-width: 768px) {
    margin-left: 40%;
  }
  @media (max-width: 520px) {
    margin-left: 25%;
  }
`;
const ButtonWrapper = styled.div`
  padding: 1rem 2rem;
  max-width: 100%;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
    padding: 1rem;
  }
`;
const StyledImg = styled(LazyLoadImage)`
  @media (max-width: 768px) {
    height: 450px;
    justify-items: end;
  }
  @media (max-width: 520px) {
    height: 320px;
    justify-items: end;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 2.5rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 19px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  // color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

export default class KioskSecondPage extends React.Component<any, any> {
  animation?: AnimationItem;
  isCMounted = true;

  constructor(props: any) {
    super(props);
    this.state = {
      alreadyAnimated: false,
      alreadyAnimatedFade: false,
    };
    this.animation = undefined;
    this.myRef = React.createRef();
  }

  scrollFunction = () => {
    if (this.isCMounted && !this.state.alreadyAnimated) {
      const currentTopPosition = window.pageYOffset;
      if (currentTopPosition > 0) {
        this.animation?.play();
        setTimeout(() => this.setState({ alreadyAnimated: true }), 100);
        setTimeout(() => this.setState({ alreadyAnimatedFade: true }), 450);
      }
    }
  };

  componentWillUnmount() {
    this.isCMounted = false;
  }
  componentDidMount() {
    this.myRef.current.addEventListener('load', (event) => {
      create({
        mode: 'scroll',
        player: '#lottie-animation-header',
        actions: [
          {
            visibility: [0, 1],
            type: 'seek',
            frames: [0, 300],
          },
        ],
      });
    });

    this.isCMounted = true;
    window.onscroll = this.scrollFunction;
    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-header')!,
      loop: false,
      renderer: 'canvas',
      autoplay: false,
      animationData: require('../../lottieAnimations/Flying_circles.json'),
    });
  }

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionItemContainer>
            <GridLeft>
              <HeroTitle
                className={`${this.state.alreadyAnimated ? 'animate-up' : ''}`}
              >
                Join Esper’s Ecosystem <br />
                of Android Partnerships
              </HeroTitle>
              <Fade when={this.state.alreadyAnimatedFade}>
                <HeroSubTitle style={{ paddingTop: '1rem' }}>
                  Team up with Esper, the industry’s first DevOps platform{' '}
                  <br />
                  for single-purpose Android devices.
                </HeroSubTitle>
                <ButtonWrapper>
                  <BlueButton onClick={() => navigate(`#section-one-partner`)}>
                    Start Now
                  </BlueButton>
                </ButtonWrapper>
              </Fade>
            </GridLeft>
            <GridRight ref={this.myRef} id="lottie-animation-header" />
          </SectionItemContainer>
          <GridMobile>
            <StyledImg src={Mobile} />
          </GridMobile>
        </SectionOne>
      </div>
    );
  }
}
